module.exports = {
  aboutPageTitle: 'Nous',
  agendaPageTitle: 'Agenda',
  relatedContent: 'Contenu connexe',
  news: 'News',
}
